import { useState } from "react";

import { rescheduleCancelledAppointmentsApi } from "@/utils/apis/doctor/appointment";

import { IAppointmentPermissionEnums } from "@/models/permission";
import { IModalKeyEnums } from "@/models/permission";

import { useAppSelector } from "@/store/hooks";
import { usePermissionRestriction } from "./usePermissionRestriction";

const useRescheduleCancelledAppointments = () => {
  const [rescheduleSlotNo, setRescheduleSlotNo] = useState<string>("");

  const { appointmentDetail, makePatientAppointment } = useAppSelector(
    (state) => state.appointment
  );

  const permissionRestrictionHandler = usePermissionRestriction();

  const rescheduleCancelledAppointments = async (
    id?: string,
    slotId?: string,
    fee?: number
  ) => {
    try {
      const isRescheduleAppointmentPermissionGranted =
        permissionRestrictionHandler(
          IModalKeyEnums.APPOINTMENT,
          IAppointmentPermissionEnums.RESCHEDULE_APPOINTMENT
        );
      if (!isRescheduleAppointmentPermissionGranted) return;

      const rescheduleAppointmentResponse =
        await rescheduleCancelledAppointmentsApi({
          id: id ?? appointmentDetail?.id,
          paymentAmount: fee ?? makePatientAppointment?.fee,
          slotId: slotId ?? makePatientAppointment?.slotId,
        });
      if ("result" in rescheduleAppointmentResponse) {
        setRescheduleSlotNo(
          rescheduleAppointmentResponse?.result?.slotNo.toString()
        );
      } else {
        return { message: rescheduleAppointmentResponse?.message };
      }
    } catch (e) {
      console.log(e);
    }
  };
  return { rescheduleCancelledAppointments, rescheduleSlotNo };
};

export default useRescheduleCancelledAppointments;
